import * as React from "react"

import { cn } from "@/lib/utils"

export type InputSize = "sm" | "md" | "lg" | "xl"

export type InputProps = Omit<React.ComponentProps<"input">, "size"> & {
  size?: InputSize
  onValueChange?: (value: string) => void
}

export const inputWrapperClassName = cn(
  `flex h-9 w-full min-w-0 rounded-md border border-input hover:border-border-hover bg-background px-3 py-1 text-base shadow-xs
  transition-[color,box-shadow,border-color] duration-100 outline-none selection:bg-primary selection:text-primary-foreground file:inline-flex
  file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-secondary/50
  disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50 md:text-sm`,
  "focus-visible:border-primary focus-visible:ring-[1px] focus-visible:ring-primary",
  "aria-invalid:border-destructive aria-invalid:ring-destructive/20 dark:aria-invalid:ring-destructive/40",
)

function Input({ className, type, size = "md", onValueChange, ...props }: InputProps) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        inputWrapperClassName,
        className,
        size === "xl" && "h-12.5 text-base md:text-lg",
        size === "lg" && "h-11 text-base md:text-base",
        size === "sm" && "h-8 text-xs md:text-xs px-1.5",
      )}
      {...props}
      onChange={(e) => {
        onValueChange?.(e.target.value)
        props.onChange?.(e)
      }}
    />
  )
}

export { Input }
